import React from 'react'

function Footer () {
  return (
    <footer className='bg-black text-white flex justify-center items-center w-full'>
      <p>&copy; Copyrights @ {new Date().getFullYear()} Nativeorange, LLC.</p>
    </footer>
  )
}

export default Footer
